(function () {
  'use strict';

  var pathLocale = window.location.pathname.match(/^\/(de|fr|it)(?:\/|$)/i);
  var locale = pathLocale
    ? pathLocale[1].toLowerCase()
    : (document.documentElement.lang || '').toLowerCase().slice(0, 2);

  if (['de', 'fr', 'it'].indexOf(locale) === -1) return;

  function normalise(value) {
    return String(value || '')
      .replace(/[’‘]/g, "'")
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase(locale);
  }

  function isAllCaps(value) {
    var letters = String(value || '').replace(/[^A-Za-zÀ-ÖØ-öø-ÿÄÖÜäöü]/g, '');
    return letters.length > 1 && letters === letters.toLocaleUpperCase(locale);
  }

  function preserveCase(source, replacement) {
    return isAllCaps(source) ? replacement.toLocaleUpperCase(locale) : replacement;
  }

  var dictionaries = {
    de: {
      'weiter shoppen': 'Weiter einkaufen',
      'teilen schließen': 'Teilen schliessen',
      'schließen': 'Schliessen',
      'großhandel': 'Grosshandel',
      'auschecken': 'Zur Kasse',
      'versand wird beim checkout berechnet': 'Versand wird an der Kasse berechnet',
      'steuern und versand werden beim checkout berechnet': 'Steuern und Versand werden an der Kasse berechnet',
      'steuern und versand werden beim checkout berechnet.': 'Steuern und Versand werden an der Kasse berechnet.',
      'melden sie sich an, damit es beim checkout schneller geht.': 'Melden Sie sich an, um schneller zu bestellen.',
      'fulfillmentstatus': 'Versandstatus',
      'tracking-link': 'Link zur Sendungsverfolgung',
      'trackingnummer': 'Sendungsnummer',
      'einloggen': 'Anmelden',
      'login': 'Anmelden',
      'verkaufspreis': 'Aktionspreis',
      'in ihrem bereich ansehen': 'In Ihrem Raum ansehen',
      'shop-informationen': 'Standortinformationen',
      'medien-galerie': 'Mediengalerie',
      'galerie-viewer': 'Galerieansicht',
      'name ihrer kategorie': 'Name Ihrer Kollektion',
      'nach kollektion entdecken': 'Kollektionen entdecken',
      'bestseller & bundles': 'Bestseller & Sets',
      'stimmen aus der community': 'Stimmen unserer Kundinnen und Kunden',
      'was unsere kund:innen sagen.': 'Was unsere Kundinnen und Kunden sagen.',
      'kund:innen': 'Kundinnen und Kunden',
      'verifizierte bewertungen & wiederkehrende kund:innen': 'Verifizierte Bewertungen & wiederkehrende Kundschaft',
      'wählen sie die passende swiss nutri routine.': 'Wählen Sie die passende Swiss Nutri-Routine.',
      'stellen sie sich ihre swiss nutri routine zusammen.': 'Stellen Sie sich Ihre Swiss Nutri-Routine zusammen.',
      'die meistgewählte swiss nutri kollektion für eine unkomplizierte tägliche routine.': 'Die meistgewählte Swiss Nutri-Kollektion für eine unkomplizierte tägliche Routine.',
      'sehen sie preis, menge, varianten und bewertungen in einer sauberen, leicht scanbaren darstellung.': 'Sehen Sie Preis, Menge, Varianten und Bewertungen übersichtlich auf einen Blick.',
      'swiss post versand': 'Versand mit Swiss Post',
      'customers are saying': 'Das sagen unsere Kundinnen und Kunden',
      'verified': 'Verifiziert',

      'regular price': 'Regulärer Preis',
      'sold out': 'Ausverkauft',
      'unavailable': 'Nicht verfügbar',
      'sale': 'Angebot',
      'quantity': 'Anzahl',
      'add to cart': 'In den Warenkorb',
      'view details': 'Details anzeigen',
      'all topics': 'Alle Themen',
      'posted in': 'Veröffentlicht in',
      'read more': 'Weiterlesen',
      'leave a comment': 'Kommentar hinterlassen',
      'email': 'E-Mail',
      'message': 'Kommentar',
      'post comment': 'Kommentar veröffentlichen',
      'please note, comments must be approved before they are published': 'Bitte beachten Sie, dass Kommentare vor der Veröffentlichung freigegeben werden müssen.',
      'your comment was posted successfully. we will publish it in a little while, as our blog is moderated.': 'Ihr Kommentar wurde erfolgreich übermittelt. Nach der Moderation wird er veröffentlicht.',
      'your comment was posted successfully! thank you!': 'Ihr Kommentar wurde erfolgreich veröffentlicht. Vielen Dank!',
      'enter store using password:': 'Shop mit Passwort öffnen:',
      'password': 'Passwort',
      'your password': 'Ihr Passwort',
      'enter': 'Öffnen',
      'we will send you an email right before we open!': 'Wir informieren Sie per E-Mail, sobald der Shop öffnet.',
      'enter using password': 'Mit Passwort öffnen'
    },

    fr: {
      'livraison gratuite pour les commandes de plus de chf 120.–': 'Livraison gratuite dès CHF 120.–',
      'commande avant 14 h 00': 'commande avant 14 h',
      'total des critiques': 'Avis au total',
      'contenu réductible': 'Contenu repliable',
      'vente': 'En promotion',
      'afficher dans son espace': 'Voir dans votre espace',
      'visionneuse de la galerie': 'Galerie',
      'galerie de supports multimédias': 'Galerie multimédia',
      'vous possédez un compte ?': 'Vous avez un compte ?',
      "continuer en tant qu'invité(e)": 'Continuer sans compte',
      'statut des paiements': 'Statut du paiement',
      'statut des commandes': "Statut d'expédition",
      'réinitialiser son mot de passe': 'Réinitialiser votre mot de passe',
      'les avis de notre communauté': 'Avis de nos clients',
      'découvrir les best-sellers': 'Voir les meilleures ventes',
      'best-sellers & packs': 'Meilleures ventes & packs',
      'customers are saying': 'Ce que disent nos clients',
      'verified': 'Vérifié',

      'regular price': 'Prix habituel',
      'sold out': 'Épuisé',
      'unavailable': 'Non disponible',
      'sale': 'En promotion',
      'quantity': 'Quantité',
      'add to cart': 'Ajouter au panier',
      'view details': 'Voir les détails',
      'all topics': 'Tous les sujets',
      'posted in': 'Publié dans',
      'read more': 'Lire la suite',
      'leave a comment': 'Laisser un commentaire',
      'email': 'E-mail',
      'message': 'Commentaire',
      'post comment': 'Publier le commentaire',
      'please note, comments must be approved before they are published': "Veuillez noter que les commentaires doivent être approuvés avant d'être publiés.",
      'your comment was posted successfully. we will publish it in a little while, as our blog is moderated.': 'Votre commentaire a bien été envoyé. Il sera publié après modération.',
      'your comment was posted successfully! thank you!': 'Votre commentaire a bien été publié. Merci !',
      'enter store using password:': 'Accéder à la boutique avec un mot de passe :',
      'password': 'Mot de passe',
      'your password': 'Votre mot de passe',
      'enter': 'Accéder',
      'we will send you an email right before we open!': "Nous vous enverrons un e-mail dès l'ouverture de la boutique.",
      'enter using password': 'Accéder avec un mot de passe'
    },

    it: {
      'spedizione gratuita per ordini superiori a chf 120.–': 'Spedizione gratuita da CHF 120.–',
      'continua lo shopping': 'Continua gli acquisti',
      'impaginazione': 'Paginazione',
      'cursore': 'Carosello',
      'carousel': 'Carosello',
      'scorrimento': 'Diapositiva',
      'recensioni totali': 'Totale recensioni',
      'contenuto comprimibile': 'Contenuto espandibile',
      'la tua password': 'La Sua password',
      'sei il proprietario del negozio?': 'È il proprietario del negozio?',
      'il tuo carrello': 'Il Suo carrello',
      'il tuo carrello è vuoto': 'Il Suo carrello è vuoto',
      'hai un account?': 'Ha un account?',
      'hai dimenticato la password?': 'Ha dimenticato la password?',
      'non hai ancora effettuato ordini.': 'Non ha ancora effettuato ordini.',
      'riceverai un\'email per reimpostare la tua password': 'Riceverà un e-mail per reimpostare la Sua password.',
      'ti abbiamo inviato un\'email con un link per aggiornare la password.': 'Le abbiamo inviato un e-mail con un link per aggiornare la password.',
      'il tuo buono regalo': 'Il Suo buono regalo',
      'codice del buono regalo': 'Codice del buono regalo',
      'check-out': 'Alla cassa',
      'visualizza nel tuo spazio': 'Visualizza nel Suo spazio',
      'visualizzatore di galleria': 'Galleria',
      'galleria contenuti multimediali': 'Galleria multimediale',
      'scopra per collezione': 'Scopra le collezioni',
      'veda tutte le collezioni': 'Scopra tutte le collezioni',
      'bestseller & bundle': 'Bestseller e set',
      'apprezzati nella quotidianità': 'Apprezzati ogni giorno',
      'maggiori informazioni su swiss nutri': 'Scopra di più su Swiss Nutri',
      'veda la garanzia': 'Scopra la garanzia',
      'le voci della nostra community': 'Le opinioni dei nostri clienti',
      'consegna rapida e affidabile direttamente a casa sua.': 'Consegna rapida e affidabile direttamente a domicilio.',
      'customers are saying': 'Cosa dicono i nostri clienti',
      'verified': 'Verificato',

      'regular price': 'Prezzo di listino',
      'sold out': 'Esaurito',
      'unavailable': 'Non disponibile',
      'sale': 'In offerta',
      'quantity': 'Quantità',
      'add to cart': 'Aggiungi al carrello',
      'view details': 'Vedi dettagli',
      'all topics': 'Tutti gli argomenti',
      'posted in': 'Pubblicato in',
      'read more': 'Leggi di più',
      'leave a comment': 'Lascia un commento',
      'email': 'Indirizzo email',
      'message': 'Commento',
      'post comment': 'Pubblica commento',
      'please note, comments must be approved before they are published': 'I commenti devono essere approvati prima della pubblicazione.',
      'your comment was posted successfully. we will publish it in a little while, as our blog is moderated.': 'Il Suo commento è stato inviato correttamente. Sarà pubblicato dopo la moderazione.',
      'your comment was posted successfully! thank you!': 'Il Suo commento è stato pubblicato. Grazie!',
      'enter store using password:': 'Acceda al negozio con la password:',
      'password': 'Password',
      'your password': 'La Sua password',
      'enter': 'Accedi',
      'we will send you an email right before we open!': "Le invieremo un'e-mail non appena il negozio sarà aperto.",
      'enter using password': 'Accedi con password'
    }
  };

  var dictionary = dictionaries[locale];

  function replaceKnownText(raw) {
    if (!raw || !raw.trim()) return raw;
    var trimmed = raw.trim();
    var key = normalise(trimmed);
    var replacement = dictionary[key];

    if (!replacement) {
      if (locale === 'de') {
        var backMatchDe = trimmed.match(/^Back to (.+)$/i);
        if (backMatchDe) replacement = 'Zurück zu ' + backMatchDe[1];
        var byMatchDe = trimmed.match(/^by\s+(.+)$/i);
        if (byMatchDe) replacement = 'von ' + byMatchDe[1];
        var commentMatchDe = trimmed.match(/^(\d+) comments?$/i);
        if (commentMatchDe) replacement = commentMatchDe[1] + (commentMatchDe[1] === '1' ? ' Kommentar' : ' Kommentare');
      }

      if (locale === 'fr') {
        var backMatchFr = trimmed.match(/^Back to (.+)$/i);
        if (backMatchFr) replacement = 'Retour à ' + backMatchFr[1];
        var byMatchFr = trimmed.match(/^by\s+(.+)$/i);
        if (byMatchFr) replacement = 'par ' + byMatchFr[1];
        var commentMatchFr = trimmed.match(/^(\d+) comments?$/i);
        if (commentMatchFr) replacement = commentMatchFr[1] + (commentMatchFr[1] === '1' ? ' commentaire' : ' commentaires');
        if (/^Du\s+CHF\b/i.test(trimmed)) replacement = trimmed.replace(/^Du\s+/i, 'Dès ');
      }

      if (locale === 'it') {
        var backMatchIt = trimmed.match(/^Back to (.+)$/i);
        if (backMatchIt) replacement = 'Torna a ' + backMatchIt[1];
        var byMatchIt = trimmed.match(/^by\s+(.+)$/i);
        if (byMatchIt) replacement = 'di ' + byMatchIt[1];
        var commentMatchIt = trimmed.match(/^(\d+) comments?$/i);
        if (commentMatchIt) replacement = commentMatchIt[1] + (commentMatchIt[1] === '1' ? ' commento' : ' commenti');
      }
    }

    if (!replacement) {
      var adjusted = trimmed;

      if (locale === 'fr') {
        adjusted = adjusted
          .replace(/\b4\.8\/5\b/g, '4,8/5')
          .replace(/\b4\.8\s+étoiles\b/gi, '4,8 étoiles')
          .replace(/livraison gratuite pour les commandes de plus de CHF 120\.–/gi, 'livraison gratuite dès CHF 120.–')
          .replace(/La livraison est gratuite pour les commandes de plus de CHF 120\.–\./g, 'La livraison est gratuite dès CHF 120.–.')
          .replace(/Frais d['’]expédition/gi, 'Frais de livraison');
      }

      if (locale === 'it') {
        adjusted = adjusted
          .replace(/\b4\.8\/5\b/g, '4,8/5')
          .replace(/\b4\.8\s+stelle\b/gi, '4,8 stelle')
          .replace(/spedizione gratuita per ordini superiori a CHF 120\.–/gi, 'spedizione gratuita da CHF 120.–')
          .replace(/La spedizione è gratuita per ordini superiori a CHF 120\.–\./g, 'La spedizione è gratuita da CHF 120.–.')
          .replace(/al momento del check-out/gi, 'al momento del pagamento')
          .replace(/al check-out/gi, 'al pagamento')
          .replace(/al momento del checkout/gi, 'al momento del pagamento')
          .replace(/al checkout/gi, 'al pagamento');
      }

      if (locale === 'de') {
        adjusted = adjusted
          .replace(/beim Checkout/g, 'an der Kasse')
          .replace(/beim checkout/g, 'an der Kasse');
      }

      if (adjusted !== trimmed) replacement = adjusted;
    }

    if (!replacement || replacement === trimmed) return raw;

    var leading = (raw.match(/^\s*/) || [''])[0];
    var trailing = (raw.match(/\s*$/) || [''])[0];
    return leading + preserveCase(trimmed, replacement) + trailing;
  }

  function localizeTextNode(node) {
    if (!node || !node.nodeValue || !node.parentElement) return;
    if (/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(node.parentElement.tagName)) return;

    var updated = replaceKnownText(node.nodeValue);
    if (updated !== node.nodeValue) node.nodeValue = updated;
  }

  function localizeAttributes(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return;
    ['placeholder', 'aria-label', 'title', 'value'].forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) return;
      var current = element.getAttribute(attribute);
      var updated = replaceKnownText(current);
      if (updated !== current) element.setAttribute(attribute, updated);
    });
  }

  function localizeAddToCart(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selectors = [
      'button[name="add"]',
      '.product-form__submit',
      'product-form button[type="submit"]',
      '[data-add-to-cart]',
      '.pf-product-form button[type="submit"]'
    ];

    scope.querySelectorAll(selectors.join(',')).forEach(function (button) {
      var current = normalise(button.textContent);
      var replacement = null;

      if (locale === 'de' && (current === 'bestellen' || current === 'add to cart')) replacement = 'In den Warenkorb';
      if (locale === 'fr' && (current === 'acheter maintenant' || current === 'add to cart')) replacement = 'Ajouter au panier';
      if (locale === 'it' && (current === 'compra ora' || current === 'add to cart')) replacement = 'Aggiungi al carrello';

      if (!replacement) return;

      var textNodes = Array.prototype.filter.call(button.childNodes, function (node) {
        return node.nodeType === Node.TEXT_NODE && node.nodeValue.trim();
      });

      if (textNodes.length) {
        textNodes[0].nodeValue = preserveCase(textNodes[0].nodeValue.trim(), replacement);
      } else {
        button.textContent = preserveCase(button.textContent.trim(), replacement);
      }
    });
  }

  function localizeShippingPrice(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var elements = scope.querySelectorAll('p, span, div, li, td, th');

    elements.forEach(function (element) {
      if (element.children.length) return;
      var text = element.textContent || '';
      if (text.indexOf('CHF 4.95') === -1) return;

      var context = element.closest('.cart, cart-drawer, .drawer, [class*="shipping"], [class*="delivery"], [class*="versand"], [class*="livraison"], [class*="spedizione"], details');
      var contextText = context ? context.textContent : text;
      if (!/shipping|delivery|versand|lieferung|livraison|expédition|spedizione|consegna/i.test(contextText)) return;

      element.textContent = text.replace(/CHF 4\.95/g, 'CHF 6.95');
    });
  }

  function localizeRoot(root) {
    var scope = root && root.nodeType ? root : document.body;
    if (!scope) return;

    if (scope.nodeType === Node.TEXT_NODE) {
      localizeTextNode(scope);
      return;
    }

    if (scope.nodeType === Node.ELEMENT_NODE) localizeAttributes(scope);

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(localizeTextNode);

    if (scope.querySelectorAll) {
      scope.querySelectorAll('[placeholder], [aria-label], [title], input[value], button[value]').forEach(localizeAttributes);
    }

    localizeAddToCart(scope);
    localizeShippingPrice(scope);
  }

  function run() {
    localizeRoot(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var scheduled = false;
  var observer = new MutationObserver(function (mutations) {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(function () {
      scheduled = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') localizeTextNode(mutation.target);
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) localizeRoot(node);
        });
      });
      localizeAddToCart(document);
    });
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();
